/** #895 / #980 — never reconcile playback via GetTransportInfo for local-native / exclusive engine. */

import { TransportCommand } from './TransportCommand';
import { exclusiveEngineReportsPlaying, isLocalNativeRendererId, isLocalNativeZone } from './localNativeRenderer';
import { fetchExclusiveEngineState } from './localNativePlaybackVerify';

export type ReconcileTransportInfoSkipReason =
  | 'local-native-zone'
  | 'local-native-renderer'
  | 'exclusive-active'
  | 'exclusive-engine-playing';

export type ReconcileTransportInfoSkip = {
  skip: true;
  reason: ReconcileTransportInfoSkipReason;
};

export type ReconcileTransportInfoProceed = { skip: false };

export type ReconcileTransportInfoGateResult =
  | ReconcileTransportInfoSkip
  | ReconcileTransportInfoProceed;

/** True when GetTransportInfo must not drive UI playback state (#895 extension). */
export async function shouldSkipGetTransportInfoReconcile(input: {
  zone: { id?: string; type?: string } | null | undefined;
  rendererId: string | null | undefined;
}): Promise<ReconcileTransportInfoGateResult> {
  if (isLocalNativeZone(input.zone)) {
    return { skip: true, reason: 'local-native-zone' };
  }
  if (isLocalNativeRendererId(input.rendererId)) {
    return { skip: true, reason: 'local-native-renderer' };
  }
  if (TransportCommand.isExclusiveActive()) {
    return { skip: true, reason: 'exclusive-active' };
  }
  const engine = await fetchExclusiveEngineState();
  if (exclusiveEngineReportsPlaying(engine)) {
    return { skip: true, reason: 'exclusive-engine-playing' };
  }
  return { skip: false };
}
